module.exports = __webpack_public_path__ + "static/media/wizualizacja-126.1478a0d5.png";